import { TransactionType } from 'global/Securities/types/transaction';

interface FormErrorItem {
  errorCondition: boolean;
  message?: string;
}

const getErrorListValidation = (
  errorList: FormErrorItem[],
): FormErrorItem | null => {
  for (let i = 0; i < errorList.length; i += 1) {
    const { errorCondition } = errorList[i];
    if (errorCondition) return errorList[i];
  }

  return null;
};

const useSplitOrderValidation = (transactionType: TransactionType) => {
  const getValidateQuantityField = (
    quantity: number,
    min: number,
    max: number,
    orderLot: number,
  ): FormErrorItem | null =>
    getErrorListValidation([
      {
        errorCondition: quantity <= 1,
        message: 'Split Quantity must be higher than 1',
      },
      {
        errorCondition: quantity > orderLot,
        message: `Split Quantity must be lower or equal to ${transactionType} Order Lot`,
      },
      {
        errorCondition: quantity * min > orderLot && min <= max,
        message: '',
      },
      {
        errorCondition: quantity * max < orderLot && min <= max,
        message: '',
      },
    ]);

  const getValidateMinRangeField = (
    quantity: number,
    min: number,
    max: number,
    buyOrderLot: number,
  ): FormErrorItem | null =>
    getErrorListValidation([
      {
        errorCondition: min > max,
        message: 'Min Range must be lower than Max Range',
      },
      {
        errorCondition: min > buyOrderLot,
        message: `Min Range must be lower than ${transactionType} Order Lot`,
      },
      {
        errorCondition: quantity * min > buyOrderLot,
        message: `Total of Split Quantity and Min Range must not exceed ${transactionType} Order Lot`,
      },
    ]);

  const getValidateMaxRangeField = (
    quantity: number,
    min: number,
    max: number,
    buyOrderLot: number,
  ): FormErrorItem | null =>
    getErrorListValidation([
      {
        errorCondition: min > max,
        message: 'Min Range must be lower than Max Range',
      },
      {
        errorCondition: quantity * max < buyOrderLot,
        message: `Total of Split Quantity and Max Range must be higher or equal to ${transactionType} Order Lot`,
      },
    ]);

  return {
    getValidateQuantityField,
    getValidateMinRangeField,
    getValidateMaxRangeField,
  };
};

export default useSplitOrderValidation;
